import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  statistics: {
    countLicense: 0,
    countLicenseActived: 0,
    countLicenseWaiting: 0,
    countUnit: 0,
    countUnitActived: 0,
    countUnitWaiting: 0,
    countDevice: 0,
    countDeviceActived: 0,
    countDeviceWaiting: 0,
  },
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    // Fetch statistics
    fetchStatistics: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchStatisticsSuccess: (state, action) => {
      state.loading = false;
      state.statistics = action.payload;
      state.error = null;
    },
    fetchStatisticsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Clear error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  fetchStatistics,
  fetchStatisticsSuccess,
  fetchStatisticsFailure,
  clearError,
} = dashboardSlice.actions;

// Selectors
export const selectStatistics = (state) => state.dashboard?.statistics || initialState.statistics;
export const selectDashboardLoading = (state) => state.dashboard?.loading || false;
export const selectDashboardError = (state) => state.dashboard?.error;

export default dashboardSlice.reducer;
